/* eslint-disable react/require-default-props */
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {
  ChangeEvent, useRef, useState,
} from 'react';
import { Col, Row } from 'react-bootstrap';
import { PrimaryButton } from '../button/Button';

interface IProps {
  keyName: string;
  required?: boolean;
  label?: string;
  className?: string;
  formIsValidated?:boolean;
}

const maxAllowedFileSizeInMB = 0.5;

const formatBytes = (bytes: number, decimals = 2): string => {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};

export default function UploadFormFileInput({
  keyName, required, label, className, formIsValidated,
}:IProps): JSX.Element {
  const ref = useRef<HTMLInputElement>(null);
  const [uploadFile, setUploadFile] = useState<File>();
  const warning = formIsValidated && !uploadFile;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const didfileExceedMaxSize = uploadFile && uploadFile?.size > 1024 * 1024 * maxAllowedFileSizeInMB;

  return (
    <Row className={className}>
      <Col xs="auto" className="justify-content-center">
        <div className="d-flex justify-content-end">
          <input
            type="file"
            accept=".pdf"
            name={keyName}
            required={required}
            ref={ref}
            className="d-none"
            onChange={(event: ChangeEvent<HTMLInputElement>) => { setUploadFile(event.target?.files?.[0]); }}
          />
          <PrimaryButton
            // className={uploadFile ? 'rounded-pill me-3' : 'rounded-circle p-2 me-3'}
            className={uploadFile ? 'rounded-circle p-2 me-3' : 'rounded-pill me-3'}
            onClick={() => ref.current?.click()}
          >
            <FontAwesomeIcon icon={faCloudArrowUp} />
          </PrimaryButton>
        </div>
      </Col>

      <Col>
        <div style={{ color: warning ? 'red' : undefined }}>{label}</div>
        {uploadFile && (
        <div>
          {uploadFile?.name}
          {' : '}
          {formatBytes(uploadFile?.size)}
        </div>
        )}
      </Col>
    </Row>
  );
}
